import { render, staticRenderFns } from "./UpdateAddress.vue?vue&type=template&id=4b8ab5a8&scoped=true"
import script from "./UpdateAddress.vue?vue&type=script&lang=js"
export * from "./UpdateAddress.vue?vue&type=script&lang=js"
import style0 from "./UpdateAddress.vue?vue&type=style&index=0&id=4b8ab5a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8ab5a8",
  null
  
)

export default component.exports